import { createContext, useMemo } from 'react';
import { useSafeContext } from '@mews/framework';
import { AgeCategory } from '@mews-commander/data-access';
import { keyById } from '@mews/fp';
import { sortAgeCategories } from '@mews-commander/legacy-entities/src/ducks/ageCategories';
import { WithChildren } from '@optimus-web/common';

interface AgeCategoriesContextValue {
    ageCategoriesById: Record<string, AgeCategory>;
    sortedAgeCategories: AgeCategory[];
    defaultAgeCategory: AgeCategory | undefined;
}

const AgeCategoriesContext = createContext<AgeCategoriesContextValue | null>(null);

AgeCategoriesContext.displayName = 'AgeCategoriesContext';

export const AgeCategoriesContextProvider: React.FC<{ ageCategories: AgeCategory[] | undefined } & WithChildren> = ({
    children,
    ageCategories,
}) => {
    const contextValue = useMemo(
        () => ({
            ageCategoriesById: keyById(ageCategories),
            sortedAgeCategories: sortAgeCategories(ageCategories ?? []),
            defaultAgeCategory: ageCategories?.find(({ isDefault }) => isDefault),
        }),
        [ageCategories]
    );

    return <AgeCategoriesContext.Provider value={contextValue}>{children}</AgeCategoriesContext.Provider>;
};

export const useAgeCategoriesContext = () => useSafeContext(AgeCategoriesContext);
